const isAudioLink = (url) => {
  const regex = /\.(mp3|wav|ogg|m4a|flac|aac|wma)$/i;
  const fileName = url.slice(
    url.lastIndexOf("/") + 1
  );

  return regex.test(url) || fileName.toUpperCase().startsWith("AUD");
};
export default isAudioLink;
